var Rect =
/** @class */
function () {
  function Rect(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.left = x;
    this.right = x + width;
    this.top = y;
    this.bottom = y + height;
    this.width = width;
    this.height = height;
    this.x = x;
    this.y = y;
  }

  Rect.prototype.toJSON = function () {};

  return Rect;
}();

export { Rect };